import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { provideAppFirebase } from './app/core/firebase.providers';
import { bootstrapAppLocale } from './locale.bootstrap';

bootstrapAppLocale();

bootstrapApplication(AppComponent, {
  providers: [...appConfig.providers, ...provideAppFirebase()],
}).catch(err => console.error(err));
